/// <reference types="vite/client" />
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import useParties from '../useParties/useParties';
import { spiceroad } from '..';

export interface UseLocProps {
  activeLOC: any;
  locError: any;
  locLoading: boolean;
  ifEnabled: boolean;
  cardRegistered: boolean;
  isPaidInFull: boolean;
  query: UseQueryResult<any>;
}

const getLOC = (locId: string) =>
  spiceroad.get(`/v1/locs/${locId}`).then((res) => res.data);

export const getLOCOpts = (locId: string) =>
  queryOptions({
    queryKey: ['loc', locId],
    queryFn: () => getLOC(locId),
  });

export function useLOC(): UseLocProps {
  const { hasLOC, isLoadingParties, isErrorParties } = useParties();
  const query = useQuery({
    ...getLOCOpts(hasLOC!),
    enabled: !!hasLOC,
  });
  const { data, error, isLoading } = query;

  const activeLOC = data?.status === 'ACTIVE' ? data : null;
  const ifsDetails = activeLOC?.instantFunding;

  const ifEnabled =
    import.meta.env['VITE_INSTANT_FUNDING_DRAW_DISABLED'] === 'false' &&
    ifsDetails?.eligible &&
    (!activeLOC?.reamortizationStatus ||
      activeLOC?.reamortizationStatus === 'REAMORTIZED');

  const isPaidInFull = activeLOC ? activeLOC.balanceOutstanding === 0 : false;

  return <UseLocProps>{
    ifEnabled: ifEnabled,
    cardRegistered: ifsDetails?.cardInfo?.registered,
    activeLOC: activeLOC,
    locError: error || isErrorParties,
    locLoading: isLoading || isLoadingParties,
    isPaidInFull: isPaidInFull,
    query,
  };
}

export default useLOC;
